import { State } from '../app.state';

export const selectRegistration = (state: State) => state.registrationState;

